import { PhoneNumberSchema } from "@redotech/redo-model/phone/phone-number";
import { z } from "zod";

export const getTeamPhoneNumber = {
  input: z.object({}),
  output: PhoneNumberSchema.nullable(),
};
